/** Keep Fluent surfaces on the same SF Pro stack as `--app-font-sans`. */
export const fluentSegoe = {
  fontFamilyBase: 'var(--app-font-sans)',
  fontFamilyMonospace: 'var(--app-font-sans)',
  fontFamilyNumeric: 'var(--app-font-sans)',
}
